import './style';
import App from './components/app';
import { Component } from 'preact';
import { Provider } from 'preact-redux';
import 'preact/devtools';
import store from './store';

class AppContainer extends Component {
    render() {
        return (
            <Provider store={store}>
                <App />
            </Provider>
        )
    }
}

export default AppContainer



// WEBPACK FOOTER //
// ./index.js